import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { PatientCreationRequest } from 'src/app/services/stellair/model/patientCreationRequest';
import { environment } from 'src/environments/environment';

interface NgSelect {
  id: string;
  libelle: string;
}

@Component({
  selector: 'app-stellair-patient-form',
  templateUrl: './stellair-patient-form.component.html',
  styleUrls: [
    './stellair-patient-form.component.scss',
    '../modal.fragment.scss'
  ]
})
export class StellairPatientFormComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  @Output() public closeEmitter = new EventEmitter<PatientCreationRequest | undefined>();

  public formGroup: FormGroup;
  public nom: string;
  public prenom: string;
  public dateNaissance: string;
  public dateNaissanceDisplay: string;
  public nirAssure: string;

  public regimeArr: Array<NgSelect> = [];
  public naturePieceJustifArr: Array<NgSelect> = [];

  constructor(
    private _formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this._initData();
    this._initForm();
    this._formatDateAnniversaire();
  }

  public closeModal(infos?: PatientCreationRequest) {
    this.closeEmitter.emit(infos);
  }

  public onSubmit() {
    if (this.formGroup.valid) {
      const infos: PatientCreationRequest = {
        nom: this.nom,
        prenom: this.prenom,
        dateNaissance: this.dateNaissance,
        nirAssure: this.nirAssure,
        rangNaissance: this.formGroup.get('rangNaissance').value,
        regime: this.formGroup.get('regime').value,
        caisse: this.formGroup.get('caisse').value,
        centre: this.formGroup.get('centre').value,
        naturePieceJustifAmo: this.formGroup.get('naturePieceJustif').value,
      };
      this.closeModal(infos);
    }
  }

  private _initForm() {
    this.formGroup = this._formBuilder.group({
      rangNaissance: [undefined, Validators.required],
      regime: [undefined, Validators.required],
      caisse: [undefined, Validators.required],
      centre: [undefined, Validators.required],
      naturePieceJustif: [undefined, Validators.required],
    });
  }

  private _initData() {
    let regimeMap = new Map<string, string>();
    for (const [key, value] of Object.entries(PatientCreationRequest.RegimeEnum)) {
      regimeMap.set(value, value);
    }

    for (const regime of regimeList) {
      if (regimeMap.has(regime.id)) {
        this.regimeArr.push(regime);
      }
    }

    let naturePjMap = new Map<string, string>();
    for (const [key, value] of Object.entries(PatientCreationRequest.NaturePieceJustifAmoEnum)) {
      naturePjMap.set(value, value);
    }

    for (const naturePj of naturePieceJustifList) {
      if (naturePjMap.has(naturePj.id)) {
        this.naturePieceJustifArr.push(naturePj);
      }
    }
  }

  private _formatDateAnniversaire() {
    if (this.dateNaissance) {
      this.dateNaissanceDisplay = moment(this.dateNaissance, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
  }

}

const regimeList: Array<NgSelect> = [
  { id: 'REGIME_1', libelle: 'Régime général' },
  { id: 'REGIME_2', libelle: 'GAMEX / MSA' },
  { id: 'REGIME_3', libelle: 'RSI' },
  { id: 'REGIME_4', libelle: 'SNCF' },
  { id: 'REGIME_5', libelle: 'RATP' },
  { id: 'REGIME_6', libelle: 'ENIM' },
  { id: 'REGIME_7', libelle: 'Mines' },
  { id: 'REGIME_8', libelle: 'CNMSS' },
  { id: 'REGIME_9', libelle: 'CPM Banque De France' },
  { id: 'REGIME_10', libelle: 'CRPCEN' },
  { id: 'REGIME_12', libelle: 'RSAM CCIP' },
  { id: 'REGIME_14', libelle: 'Assemblée Nationale' },
  { id: 'REGIME_15', libelle: 'SENAT' },
  { id: 'REGIME_16', libelle: 'Port Aut. de Bordeaux' },
  { id: 'REGIME_17', libelle: 'Français de l\'étranger' },
  { id: 'REGIME_90', libelle: 'CAVIMAC' },
  { id: 'REGIME_91', libelle: 'MGEN' },
  { id: 'REGIME_92', libelle: 'MG' },
  { id: 'REGIME_93', libelle: 'MGP' },
  { id: 'REGIME_94', libelle: 'MFP' },
  { id: 'REGIME_95', libelle: 'MNH' },
  { id: 'REGIME_96', libelle: 'MNAM' },
  { id: 'REGIME_99', libelle: 'Section Locale Mutualiste' },
  { id: 'REGIME_INCONNU', libelle: 'Inconnu' },
];

const naturePieceJustifList: Array<NgSelect> = [
  { id: 'AUCUNE', libelle: 'Aucune' },
  { id: 'PAPIER', libelle: 'Bulletin de salaire, attestation de droits, prise en charge pour l\'AME, etc...' },
  { id: 'DISTANT', libelle: 'Carte d\'assuré social' },
];


// <option value="REGIME_1">Régime général</option>
// <option value="REGIME_2">GAMEX / MSA</option>
// <option value="REGIME_3">RSI</option>
// <option value="REGIME_4">SNCF</option>
// <option value="REGIME_5">RATP</option>
// <option value="REGIME_6">ENIM</option>
// <option value="REGIME_7">Mines</option>
// <option value="REGIME_8">CNMSS</option>
// <option value="REGIME_9">CPM Banque De France</option>
// <option value="REGIME_10">CRPCEN</option>
// <option value="REGIME_12">RSAM CCIP</option>
// <option value="REGIME_14">Assemblée Nationale</option>
// <option value="REGIME_15">SENAT</option>
// <option value="REGIME_16">Port Aut. de Bordeaux</option>
// <option value="REGIME_17">Français de l'étranger</option>
// <option value="REGIME_90">CAVIMAC</option>
// <option value="REGIME_91">MGEN</option>
// <option value="REGIME_92">MG</option>
// <option value="REGIME_93">MGP</option>
// <option value="REGIME_94">MFP</option>
// <option value="REGIME_95">MNH</option>
// <option value="REGIME_96">MNAM</option>
// <option value="REGIME_99">Section Locale Mutualiste</option>
// <option value="REGIME_INCONNU">Inconnu</option>

// <option value="AUCUNE">Aucune</option>
// <option value="PAPIER">Bulletin de salaire, attestation de droits, prise en charge pour l'AME, etc...</option>
// <option value="DISTANT">Carte d'assuré social</option>